/**
 * Token 管理配置
 * 基于 js-cookie 的 Token 存储管理
 */

import Cookies from 'js-cookie'

/**
 * Token 管理器
 */
export class TokenManager {
  private tokenKey: string

  constructor(tokenKey: string = import.meta.env.VITE_TOKEN_KEY || 'tenant_portal_token') {
    this.tokenKey = tokenKey
  }

  /**
   * 获取 Token
   */
  get(): string | undefined {
    return Cookies.get(this.tokenKey)
  }

  /**
   * 设置 Token
   */
  set(token: string, days: number = 7): void {
    const options: Cookies.CookieAttributes = {
      expires: days,
      path: '/',
      sameSite: 'lax'
    }

    // HTTPS 环境下添加 secure 标志
    if (window.location.protocol === 'https:') {
      options.secure = true
    }

    console.log('[TP_TOKEN] 设置 Token', this.tokenKey)
    Cookies.set(this.tokenKey, token, options)
  }

  /**
   * 删除 Token
   */
  remove(): void {
    Cookies.remove(this.tokenKey, { path: '/' })
  }

  /**
   * 检查 Token 是否存在
   */
  exists(): boolean {
    return !!this.get()
  }

  /**
   * 获取 Token 键名
   */
  getTokenKey(): string {
    return this.tokenKey
  }
}

// 创建默认的 Token 管理器实例
export const tokenManager = new TokenManager()
